import React from 'react';
import { findWithUUID } from '@/utils/uuidHelper';
import InEditCell from '@/components/table/InEditCell';
import { updateVocabularyLinkProperties } from '../actions';

const VocabularyLinkValueContainer = ({
  exists,
  children,
}) => (
  <InEditCell exists={exists} canRead>
    {children}
  </InEditCell>
);

const withItem = (updateErrors, {
  name, href, target, description,
}) => (
  {
    exists: true, updateErrors, name, href, target, description,
  }
);

export const mapStateToProps = ({
  vocabularies: { activeVocabulary: { urls, updateErrors } },
}, { linkUUID }) => {
  const item = findWithUUID(urls, linkUUID || '');
  return item ? withItem(updateErrors, item) : { exists: false };
};

export const mapDispatchToProps = {
  updateProperties: updateVocabularyLinkProperties,
};

export default VocabularyLinkValueContainer;
